import { arrayOf, bool, number, shape, string } from 'prop-types';

import brandPropType from './brands';

export default shape({
  brand: brandPropType,
  categories: arrayOf(shape({})),
  created_at: string,
  description: string,
  employment_type: string,
  external_identifier: string,
  id: number,
  lat: number,
  lng: number,
  locations: arrayOf(
    shape({
      remote: bool,
    })
  ),
  title: string,
  updated_at: string,
  url: string,
  logo_thumb_url: string,
});
